import { getRandom } from './getRandom';

export function shuffleArray<T>(array: T[]): T[] {
  return array.sort(getRandom);
}
